<template>
<div class="chapter">
<div class="inner_page">
<div class="bg4">
<p class="figure-aligncenter-indent"><img alt="image" src="images/pg2.jpg"/></p>
<p class="cen_tt"><i><b>Dedication</b></i></p>
<p class="center">During the summer of 2016, my daughter-in-law, Celia, requested a unicorn quilt for Christmas. Celia was specific: There had to be a big rainbow, a happy unicorn, and lots of pink—and it had to be big enough to snuggle under. Even though this was pretty far from the quilts I normally make, I said “Sure. I can do that!”</p>
<p class="center">I wasn’t excited about this quilt until I was in the middle of making it. Unicorns are magical and happy—just looking at it makes me grin!</p>
<p class="center">Thank you, Celia!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedicationtitle.vue?71dfd953